import request from '../utils/http'
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 0  // 不同小程序对接同一后台
// appid：0-维应SPR开发版、3-维应企微SPR开发版、2001-维应SPR、2002-维应企微SPR、3001-月峰教育企微SPR
// register、userLogin、resetPass

// 用户注册
export function register(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "reg",
            appid: 0,
            ...data
        }  //接口参数
    })
}

// 用户登录
export function userLogin(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login',
            appid: 0,
            ...data
        }  //接口参数
    })
}

// 忘记登录密码（重置） 282
export function resetPass(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login_mobile_uppwd',
            appid: 0,
            ...data
        }  //接口参数
    })
}


// 管理员登录
export function login(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "login_admin",
            ...data
        }  //接口参数
    })
}

// 管理员登录获取开发id 273
export function adminGuid(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "getopenid",
            ...data
        }  //接口参数
    })
}


// 获取用户信息 198
export function getUserInfo(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'getuser',
            ...data
        }  //接口参数
    })
}

// 发送手机号 280
export function sendVerfity(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'sms',
            ...data
        }  //接口参数
    })
}

// 手机号验证 281
export function verifyPhoto(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login_mobile',
            appid,
            ...data
        }  //接口参数
    })
}


// 修改登录密码 279
export function updatePass(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'updatepwd',
            appid,
            ...data
        }  //接口参数
    })
}

// sku或isbn查询商品详情 238
export function queryShop(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_base_search',
            ...data
        }  //接口参数
    })
}

// 图片上传 228
export function uploadImage(data) {
    return request({
        url: "/service_app/ImageUpload.ashx",  //接口路径
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data  //接口参数
    })
}

// 查看入库记录 240
export function queryShopWareRecord(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_basenum',
            ...data
        }  //接口参数
    })
}

// 增加品牌 212
export function addBrand(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label_brandadd',
            ...data
        }  //接口参数
    })
}

// 修改品牌 213
export function editBrand(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label_brandedit',
            ...data
        }  //接口参数
    })
}

// 获取品牌标签列表 215
export function getBrandList(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label_brand',
            ...data
        }  //接口参数
    })
}

// 新增商品一级分类标签 209
export function addComFirstLabel(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label',
            ...data
        }  //接口参数
    })
}
// 新增商品二级分类标签 210
export function addComSecondLabel(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label2add',
            ...data
        }  //接口参数
    })
}
// 新增商品三级分类标签 211
export function addComThirdLabel(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label3add',
            ...data
        }  //接口参数
    })
}
// 获取商品分类标签 214
export function getCommondityLabel(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_label',
            ...data
        }  //接口参数
    })
}

// 新增商品 231
export function addCommidity(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'ams_shop_commodityadd',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data  //接口参数
    })
}

// 获取商品详情 234
export function getCommidityDetail(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_base_view',
            ...data
        }  //接口参数
    })
}

// 获取商品详情 232
export function editCommidity(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
        // params: {
        //     Method: 'ams_shop_commodity_edit',
        //     ...data
        // }  //接口参数
    })
}

// 商品入库参数设置 239
export function setShopWareParam(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_basenumadd',
            ...data
        }  //接口参数
    })
}

// 获取生产商列表 245 后面接口320代替
export function getProducerList(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_supplier',
            ...data
        }  //接口参数
    })
}

// 获取供应商列表 320
export function getSupplierList(data) {
    return request({
        url: "/service/supplier.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'LoadPagedams_shop_supplier',
            ...data
        }  //接口参数
    })
}
// 获取供应商列表 319
export function getSupplierDetail(data) {
    return request({
        url: "/service/supplier.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_supplierView',
            ...data
        }  //接口参数
    })
}
// 增加供应商 317
export function addSupplier(data) {
    return request({
        url: "/service/supplier.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_supplierADD',
            ...data
        }  //接口参数
    })
}
// 修改供应商 318
export function editSupplier(data) {
    return request({
        url: "/service/supplier.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_supplierMod',
            ...data
        }  //接口参数
    })
}

// 获取仓库列表 244
export function getWearhouseList(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'warehouse',
            ...data
        }  //接口参数
    })
}

// 获取仓库列表-详情  245
export function getWearhouseDetail(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'warehouse_view',
            ...data
        }  //接口参数
    })
}

// 添加仓库 216
export function addWearhouse(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'warehouseadd',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 修改仓库 217
export function editWearhouse(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'warehouseedit',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 添加货架 218
export function addWearhouseShelf(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'Warehouse2add',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 修改货架 219
export function editWearhouseShelf(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'Warehouse2edit',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 添加层位 220
export function addWearhouseHorizon(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'Warehouse3add',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 修改层位 221
export function editWearhouseHorizon(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'Warehouse3edit',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 添加货位 222
export function addWearhouseSpace(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'warehouse4add',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 修改货位 223
export function editWearhouseSpace(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        // method: "get",  //接口方法
        // // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        // params: {
        //     Method: 'warehouse4edit',
        //     ...data
        // }  //接口参数
        method: "post",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data
    })
}

// 获取物流类型 237
export function getLogistics(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'service_company',
            ...data
        }  //接口参数
    })
}

// 获取属性标签 235
export function getAttrLabelList(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_attr',
            ...data
        }  //接口参数
    })
}

// 获取属性标签对应的值 236
export function getAttrLabelValue(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_attr',
            ...data
        }  //接口参数
    })
}

// 获取商品信息 52
export function getCommondity(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity',
            ...data
        }  //接口参数
    })
}

// 获取商品标签列表 241
export function getCommondityLabelList(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_attr_cm',
            ...data
        }  //接口参数
    })
}

// 获取商品标签详情 243
export function getCommondityLabelDetail(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_attrview',
            ...data
        }  //接口参数
    })
}

// 新增商品标签 242
export function addCommondityLabel(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_attradd',
            ...data
        }  //接口参数
    })
}

// 修改商品标签 242
export function editCommondityLabel(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_commodity_attredit',
            ...data
        }  //接口参数
    })
}

// 获取关键字标签 242
export function getKeywordLabel(data) {
    return request({
        url: "/service/commodity.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'view_labelall',
            ...data
        }  //接口参数
    })
}

// 创建采购数据 257
export function addPurchase(data) {
    return request({
        url: "/service/purchase.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_PurchaseAdd',
            ...data
        }  //接口参数
    })
}

// 获取采购列表 261
export function getPurchaseList(data) {
    return request({
        url: "/service/purchase.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_purchase',
            ...data
        }  //接口参数
    })
}

// 获取采购列表-详情 262
export function getPurchaseDetail(data) {
    return request({
        url: "/service/purchase.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_purchase_view',
            ...data
        }  //接口参数
    })
}

// 添加入库记录 258
export function addPurchaseWare(data) {
    return request({
        url: "/service/purchase.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_Purchase_RecordAdd',
            ...data
        }  //接口参数
    })
}

// 采购主管审核采购计划 281
export function checkPurchase(data) {
    return request({
        url: "/service/purchase.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'ams_shop_purchase_check',
            ...data
        }  //接口参数
    })
}

// 获取省市 57
export function getProvince() {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'area'
        }
    })
}

// 获取城市 58
export function getCity(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'city',
            areaid: id
        }
    })
}

// 获取区域 286
export function getArea(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'addr',
            cityid: id
        }
    })
}

// 一级模块权限 283
export function getMenuAuthOne() {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_authority_1',
        }
    })
}

// 二级模块权限 284
export function getMenuAuthTwo(id) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_authority_2',
            parentid: id
        }
    })
}

// 按钮级模块权限 285
export function getMenuAuthThree(id) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_authority_3',
            parentid: id
        }
    })
}

// 补充分类、联系形式、联系优先度、联系情况、联系结果、客户属性、客户资源分配类型 295-301
export function getQywxset(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_enum_qywxset',
            columncode: data
        }
    })
}

// 商户定价权限管理、买手定价权限管理 302、303
export function getEnumPrice(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_enum_price',
            columncode: data
        }
    })
}

// 商品销售溢价 304
export function getEnumYijia(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_enum_yijia',
            columncode: data
        }
    })
}